// import React, { useState, useEffect } from "react";
// import "../Styles/RegisterPage.css";
// import Kaas from "../Images/Kaas.png";
// import { ImUsers } from "react-icons/im";
// import { MdEmail, MdCall } from "react-icons/md";
// import { IoMdLock } from "react-icons/io";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
// import Register_Page_Laptop from "../Images/RegisterPageImg.jpg";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import PhoneInput from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import { Form, Button, Container, Row, Col, InputGroup } from 'react-bootstrap';
// // import PhoneInput from 'react-phone-input-2';
// // import 'react-phone-input-2/lib/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

// export default function RegisterPage() {
//   const URL = "https://tdtlworld.com/dss-kaas-backend/";

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     instructor: false,
//     otp: 0,
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [showOTPField, setShowOTP] = useState(false);

//   const navigate = useNavigate();

//   useEffect(() => {
//     axios
//       .get("https://restcountries.com/v3.1/all")
//       .catch((error) => console.error("Error fetching country codes:", error));
//   }, []);

//   const sendOTP = () => {
//     axios
//       .post(`${URL}/auth/verify-email/`, { email: formData.email })
//       .then(() => setShowOTP(true));
//   };

//   const signUp = () => {
//     axios
//       .post(`${URL}/auth/signup/`, {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         mobile_number: formData.phoneNumber,
//         otp: parseInt(formData.otp),
//       })
//       .then(() => navigate(`/log`));
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const validateForm = () => {
//     const { firstName, lastName, phoneNumber } = formData;

//     if (!firstName || !lastName) {
//       Swal.fire("Error", "Please enter both first and last name.", "error");
//       return false;
//     }

//     if (!phoneNumber) {
//       Swal.fire("Error", "Invalid phone number.", "error");
//       return false;
//     }

//     return true;
//   };

//   const handleSignUp = (e) => {
//     e.preventDefault();
//     if (validateForm()) signUp();
//   };

//   return (
//     <div className="container-fluid">
//       <div className="container px-0">
//         <div className="row">
//           {/* Left Column */}
//           <div className="col-sm-10 col-md-5 col-lg-5">
//             <div className="row px-4">
//               <div className="col-sm-12 mt-3">
//                 <img src={Kaas} className="logo_Register" alt="Logo" />
//                 <div className="Sign_Up_Name mt-3 mb-2">Sign Up</div>
//                 <form onSubmit={handleSignUp}>
//                   <div className="Register_Icons_div mt-3 mb-3">
//                     <ImUsers className="Register_Icons" />
//                     <input
//                       className="Input_Field_"
//                       type="text"
//                       name="firstName"
//                       placeholder="Enter Your First Name"
//                       value={formData.firstName}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div className="Register_Icons_div mt-3 mb-3">
//                     <ImUsers className="Register_Icons" />
//                     <input
//                       className="Input_Field_"
//                       type="text"
//                       name="lastName"
//                       placeholder="Enter Your Last Name"
//                       value={formData.lastName}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div className="Register_Icons_div mt-3 mb-3">
//                     <div className="d-flex align-items-center">
//                       <MdEmail className="Register_Icons" />
//                       <input
//                         className="Input_Field_"
//                         type="email"
//                         name="email"
//                         placeholder="Enter Your Email"
//                         value={formData.email}
//                         onChange={handleChange}
//                       />
//                       <button
//                         type="button"
//                         className="btn"
//                         onClick={sendOTP}
//                       >
//                         Verify
//                       </button>
//                     </div>
//                   </div>
//                   <div className="Register_Icons_div mt-3 mb-3">
//                     <MdCall className="Register_Icons" />
//                     <PhoneInput
//                       className="Phone_Input_Field"
//                       placeholder="Enter Your Phone Number"
//                       value={formData.phoneNumber}
//                       onChange={(value) =>
//                         setFormData({ ...formData, phoneNumber: value })
//                       }
//                     />
//                   </div>
//                   <div className="Register_Icons_div mt-3 mb-3 d-flex justify-content-between align-items-center">
//                     <div className="d-flex align-items-center">
//                       <IoMdLock className="Register_Icons" />
//                       <input
//                         className="Input_Field_ ml-2"
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         placeholder="Enter Your Password"
//                         value={formData.password}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <button
//                       type="button"
//                       className="btn"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       <FontAwesomeIcon
//                         icon={showPassword ? faEyeSlash : faEye}
//                       />
//                     </button>
//                   </div>
//                   {showOTPField && (
//                     <input
//                       className="Input_Field_ ml-2"
//                       name="otp"
//                       value={formData.otp}
//                       onChange={handleChange}
//                       type="text"
//                       placeholder="0000"
//                     />
//                   )}
//                   <div className="mb-2">
//                     <button
//                       type="submit"
//                       className="btn Sign_Up_Button"
//                       style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         margin: "8px 0",
//                         backgroundColor: "#b8529e",
//                         color: "white",
//                         width: "100%",
//                         fontSize: "20px",
//                       }}
//                     >
//                       Sign Up
//                     </button>
//                   </div>
//                 </form>
//                 <div className="Already_Register mt-2">
//                   Already Registered? <a href="/db-shiksha/kaas/login">Sign In</a>
//                 </div>
//                 <div className="mt-1 By_Creating">
//                   By Creating An Account, You Accept KaaS Terms Of Services & Privacy Policy
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Right Column */}
//           <div className="col-md-7 col-lg-7 mt-5 main_col2">
//             <div className="row">
//               <div className="col-sm-6 col-md-7 col-lg-6 d-flex justify-content-center">
//                 <div className="Sign_Up_Un">Sign Up Unending Learning!</div>
//               </div>
//               <div className="col-sm-6 col-md-5 col-lg-6">
//                 <img
//                   src={Register_Page_Laptop}
//                   className="Register_Page_Laptop"
//                   alt="Laptop"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from 'react'
// import '../Styles/RegisterPage.css'
// import Kaas from '../Images/Kaas 4.png'
// import Register_Page_Laptop from '../Images/RegisterPageImg.jpg'
// import { useNavigate } from 'react-router-dom'
// import Swal from 'sweetalert2'
// import PhoneInput from 'react-phone-number-input'
// import 'react-phone-number-input/style.css'
// import { Form, Button, Container, Row, Col, InputGroup } from 'react-bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa'
// import axios from 'axios'
// import { FcGoogle } from 'react-icons/fc'
// import { motion, AnimatePresence } from "framer-motion"

// import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'

// const RegisterPage = () => {
//   const URL = 'https://tdtlworld.com/dss-kaas-backend/'
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phoneNumber: '',
//     password: '',
//     otp: '',
//   })
//   const [emailError, setEmailError] = useState('')
//   const [showPassword, setShowPassword] = useState(false)
//   const [showOTPField, setShowOTPField] = useState(false)
//   const [isEmailVerified, setIsEmailVerified] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [otpLoading, setOtpLoading] = useState(false)

//   const navigate = useNavigate()

//   useEffect(() => {
//     axios
//       .get('https://restcountries.com/v3.1/all')
//       .catch((error) => console.error('Error fetching country codes:', error))
//   }, [])

//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }))
//     if (name === 'email') validateEmail(value)
//   }

//   const validateEmail = (email) => {
//     const emailRegex = /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/
//     if (!emailRegex.test(email)) {
//       setEmailError(
//         'Invalid email format. Please start with a lowercase letter.'
//       )
//     } else {
//       setEmailError('')
//     }
//   }

//   const handlePhoneChange = (value) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       phoneNumber: value,
//     }))
//   }

//   const sendOTP = () => {
//     setOtpLoading(true)
//     if (emailError) {
//       Swal.fire('Error', 'Please correct your email before verifying.', 'error')
//       return
//     }
//     axios
//       .post(`${URL}auth/verify-email/`, { email: formData.email })
//       .then(() => {
//         Swal.fire('OTP Sent', 'Please check your email for the OTP.', 'success')
//         setShowOTPField(true)
//         setIsEmailVerified(true) // Email is now verified
//       })
//       .catch(() => {
//         Swal.fire('Error', 'Failed to send OTP. Please try again.', 'error')
//         setIsEmailVerified(false) // Reset verification status
//       })
//       .finally(() => {
//         setOtpLoading(false) // stop loader whether success or fail
//       })
//   }

//   const validateForm = () => {
//     const { firstName, lastName, phoneNumber, email } = formData

//     if (!firstName || !lastName) {
//       Swal.fire('Error', 'Please enter both first and last name.', 'error')
//       return false
//     }

//     if (!phoneNumber) {
//       Swal.fire('Error', 'Invalid phone number.', 'error')
//       return false
//     }

//     if (emailError) {
//       Swal.fire('Error', 'Please correct your email format.', 'error')
//       return false
//     }

//     return true
//   }

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     setLoading(true)
//     if (!isEmailVerified) {
//       Swal.fire('Error', 'Please verify your email first.', 'error')
//       return
//     }

//     if (!validateForm()) return

//     axios
//       .post(`${URL}auth/signup/`, {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         mobile_number: formData.phoneNumber,
//         otp: parseInt(formData.otp),
//       })
//       .then(() => {
//         Swal.fire('Success', 'Your account has been created!', 'success')
//         navigate('/log')
//       })
//       .catch((error) => {
//         Swal.fire('Error', 'Registration failed. Please try again.', 'error')
//         console.error('Registration error:', error)
//       })
//       .finally(() => {
//         setLoading(false) // stop loader whether success or fail
//       })
//   }

//   const handleGoogleLoginSuccess = async (credentialResponse) => {
//     // The token should be in credentialResponse.credential
//     const token = credentialResponse.credential
//     console.log('Received Google Token:', token)

//     try {
//       // Post the token to your backend
//       const response = await axios.post(`${URL}auth/google/login/`, { token })
//       localStorage.setItem('jwttoken', response.data.access)

//       Swal.fire({
//         title: 'Success!',
//         text: 'You have logged in with Google successfully.',
//         icon: 'success',
//         timer: 1000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate('/Home')
//       })
//     } catch (error) {
//       console.error('Google login error:', error)
//       if (error.response) {
//         console.error('Error Data:', error.response.data)
//         console.error('Error Status:', error.response.status)
//       }

//       Swal.fire({
//         title: 'Error!',
//         text: error?.response?.data?.error || 'Google login failed',
//         icon: 'error',
//         confirmButtonText: 'Try Again',
//       })
//     }
//   }

//   return (
//     <GoogleOAuthProvider clientId='563227117215-cvm1hposi4qtk3kcrb3693vsq8osefts.apps.googleusercontent.com'>
//       <div className='container-fluid'>
//         <Container>
//           <Row className='justify-content-center'>
//             <Col sm={10} md={6} lg={5}>
//               <div className='text-center mb-4 mt-5'>
//                 <img
//                   src={Kaas}
//                   alt='KaaS Logo'
//                   className='img-fluid logo_Register'
//                   style={{ marginLeft: '150px' }}
//                 />
//               </div>
//               <h2
//                 className='text-center mb-4 Sign_Up_Name'
//                 style={{ color: '#3953A3' }}
//               >
//                 Sign Up
//               </h2>
//               <Form onSubmit={handleSubmit}>
//                 <Form.Group className='mb-3'>
//                   <InputGroup>
//                     <InputGroup.Text>
//                       <FaUser />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type='text'
//                       name='firstName'
//                       placeholder='Enter Your First Name'
//                       value={formData.firstName}
//                       onChange={handleChange}
//                       required
//                     />
//                   </InputGroup>
//                 </Form.Group>
//                 <Form.Group className='mb-3'>
//                   <InputGroup>
//                     <InputGroup.Text>
//                       <FaUser />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type='text'
//                       name='lastName'
//                       placeholder='Enter Your Last Name'
//                       value={formData.lastName}
//                       onChange={handleChange}
//                       required
//                     />
//                   </InputGroup>
//                 </Form.Group>
//                 <Form.Group className='mb-3'>
//                   <InputGroup>
//                     <InputGroup.Text style={{ borderRadius: '5px 0 0 5px' }}>
//                       <FaEnvelope />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type='email'
//                       name='email'
//                       placeholder='Enter Your Email'
//                       value={formData.email}
//                       onChange={handleChange}
//                       isInvalid={!!emailError}
//                       required
//                       style={{ borderRadius: '0' }}
//                     />
//                     <Button
//                       onClick={sendOTP}
//                       disabled={otpLoading}
//                       style={{
//                         backgroundColor: '#7D52A0',
//                         borderColor: '#7D52A0',
//                         borderRadius: '0 5px 5px 0',
//                       }}
//                     >
//                       {' '}
//                       {otpLoading ? (
//                         <>
//                           <span
//                             className='spinner-border spinner-border-sm'
//                             role='status'
//                             aria-hidden='true'
//                             style={{ marginRight: '8px' }}
//                           ></span>
//                           Verifying...
//                         </>
//                       ) : (
//                         'Verify'
//                       )}
//                     </Button>
//                     <Form.Control.Feedback type='invalid'>
//                       {emailError}
//                     </Form.Control.Feedback>
//                   </InputGroup>
//                 </Form.Group>

//                 <Form.Group className='mb-3'>
//                   <PhoneInput
//                     country={'us'}
//                     value={formData.phoneNumber}
//                     onChange={handlePhoneChange}
//                     inputProps={{
//                       name: 'phoneNumber',
//                       required: true,
//                     }}
//                   />
//                 </Form.Group>
//                 <Form.Group className='mb-3'>
//                   <InputGroup>
//                     <InputGroup.Text>
//                       <FaLock />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type={showPassword ? 'text' : 'password'}
//                       name='password'
//                       placeholder='Enter Your Password'
//                       value={formData.password}
//                       onChange={handleChange}
//                       required
//                     />
//                     <Button
//                       onClick={() => setShowPassword(!showPassword)}
//                       variant='outline-secondary'
//                     >
//                       {showPassword ? <FaEyeSlash /> : <FaEye />}
//                     </Button>
//                   </InputGroup>
//                 </Form.Group>
//                 {showOTPField && (
//                   <Form.Group className='mb-3'>
//                     <Form.Control
//                       type='text'
//                       name='otp'
//                       placeholder='Enter OTP'
//                       value={formData.otp}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 )}
//                 <Button
//                   type='submit'
//                   className='w-100 Sign_Up_Button'
//                   disabled={loading}
//                   style={{
//                     backgroundColor: '#B8529E',
//                     borderColor: '#B8529E',
//                     fontSize: '20px',
//                     marginTop: '10px',
//                     marginBottom: '10px',
//                   }}
//                 >
//                   {loading ? (
//                     <>
//                       <span
//                         className='spinner-border spinner-border-sm'
//                         role='status'
//                         aria-hidden='true'
//                         style={{ marginRight: '8px' }}
//                       ></span>
//                       Signing Up...
//                     </>
//                   ) : (
//                     'Sign Up'
//                   )}
//                 </Button>
//               </Form>
//               {/* <div
//               className="Register_Icons_div mt-2 mb-3 px-3"
//               style={{ width: "70%", margin: "0 auto", borderRadius: "15px" }}
//             >
//               <FcGoogle className="Register_Icons" />
//               <div>Sign up with Google</div>
//             </div> */}
//               {/* Google Sign-In Button */}
//               <motion.div
//                                   initial={{ y: 20, opacity: 0 }}
//                                   animate={{ y: 0, opacity: 1 }}
//                                   transition={{ delay: 0.9, duration: 0.5 }}
//                                   style={{ display: "flex", justifyContent: "center",marginTop:"40px" }}
//                                 >
//                                   <GoogleLogin
//                                     onSuccess={handleGoogleLoginSuccess}
//                                     onError={(error) => {
//                                       console.error("Google login error:", error)
//                                       Swal.fire({
//                                         title: "Error!",
//                                         text: error.message || "Google login failed",
//                                         icon: "error",
//                                         background: "#f8f9fa",
//                                         confirmButtonColor: "#B8529E",
//                                       })
//                                     }}
//                                     theme="outline"
//                                     size="large"
//                                     text="signin_with"
//                                     shape="pill"
//                                     logo_alignment="center"
//                                   />
//                                 </motion.div>
//               {/* <div
//                 className='Register_Icons_div d-flex justify-content-center align-items-center flex-column mt-4 mb-4'
//                 style={{
//                   width: '10%', // Matches the width of the "Sign In" button
//                   margin: '0 auto',
//                   borderRadius: '15px',
//                 }}
//               >
//                 <GoogleLogin
//                   onSuccess={handleGoogleLoginSuccess}
//                   onError={(error) => {
//                     console.error('Google login error:', error)
//                     Swal.fire({
//                       title: 'Error!',
//                       text: error.message || 'Google login failed',
//                       icon: 'error',
//                     })
//                   }}
//                   theme='outline'
//                   size='large'
//                   text='signin_with'
//                   style={{
//                     display: 'block',
//                     margin: '0 auto',
//                     borderRadius: '15px',
//                   }} // Alignment helper
//                   containerProps={{
//                     style: {
//                       width: '100%',
//                       borderRadius: '15px', // Ensures the component spans the parent container
//                     },
//                   }}
//                 />
//               </div> */}

//               <p className='text-center mt-3 Already_Register'>
//                 Already Registered?{' '}
//                 <a href='/log' style={{ color: '#8852A0' }}>
//                   Sign In
//                 </a>
//               </p>
//               <p className='text-center mt-2 By_Creating'>
//                 By Creating An Account, You Accept KaaS Terms Of Services &
//                 Privacy Policy
//               </p>
//             </Col>
//             <Col md={7} lg={7} className='mt-5 main_col2'>
//               <Row>
//                 <Col
//                   sm={6}
//                   md={7}
//                   lg={6}
//                   className='d-flex justify-content-center'
//                 >
//                   <div className='Sign_Up_Un'>Sign Up Unending Learning!</div>
//                 </Col>
//                 <Col sm={6} md={5} lg={6}>
//                   <img
//                     src={Register_Page_Laptop}
//                     className='Register_Page_Laptop'
//                     alt='Laptop'
//                   />
//                 </Col>
//               </Row>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </GoogleOAuthProvider>
//   )
// }

// export default RegisterPage
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';
// import Register_Page_Laptop from '../Images/RegisterPageImg.jpg'
// import { Form, Button, Container, Row, Col, InputGroup } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
// import axios from 'axios';
// import { motion } from "framer-motion";
// import Kaas from '../Images/Kaas 4.png'
// import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

// const RegisterPage = () => {
//   const URL = 'https://tdtlworld.com/dss-kaas-backend/';
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phoneNumber: '',
//     password: '',
//     confirmPassword: '',
//     otp: '',
//   });
//   const [emailError, setEmailError] = useState('');
//   const [passwordError, setPasswordError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [showOTPField, setShowOTPField] = useState(false);
//   const [isEmailVerified, setIsEmailVerified] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);

//   const navigate = useNavigate();

//   useEffect(() => {
//     axios
//       .get('https://restcountries.com/v3.1/all')
//       .catch((error) => console.error('Error fetching country codes:', error));
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));

//     if (name === 'email') validateEmail(value);
//     if (name === 'confirmPassword') validatePasswords(formData.password, value);
//     if (name === 'password') validatePasswords(value, formData.confirmPassword);
//   };

//   const validateEmail = (email) => {
//     const emailRegex = /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/;
//     if (!emailRegex.test(email)) {
//       setEmailError(
//         'Invalid email format. Please start with a lowercase letter.'
//       );
//     } else {
//       setEmailError('');
//     }
//   };

//   const validatePasswords = (password, confirmPassword) => {
//     if (confirmPassword && password !== confirmPassword) {
//       setPasswordError('Passwords do not match');
//     } else {
//       setPasswordError('');
//     }
//   };

//   const handlePhoneChange = (value) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       phoneNumber: value,
//     }));
//   };

//   const sendOTP = () => {
//     setOtpLoading(true);
//     if (emailError) {
//       Swal.fire('Error', 'Please correct your email before verifying.', 'error');
//       setOtpLoading(false);
//       return;
//     }
//     axios
//       .post(`${URL}auth/verify-email/`, { email: formData.email })
//       .then(() => {
//         Swal.fire('OTP Sent', 'Please check your email for the OTP.', 'success');
//         setShowOTPField(true);
//         setIsEmailVerified(true);
//       })
//       .catch(() => {
//         Swal.fire('Error', 'Failed to send OTP. Please try again.', 'error');
//         setIsEmailVerified(false);
//       })
//       .finally(() => {
//         setOtpLoading(false);
//       });
//   };

//   const validateForm = () => {
//     const { firstName, lastName, phoneNumber, email, password, confirmPassword } = formData;

//     if (!firstName || !lastName) {
//       Swal.fire('Error', 'Please enter both first and last name.', 'error');
//       return false;
//     }

//     if (!phoneNumber) {
//       Swal.fire('Error', 'Invalid phone number.', 'error');
//       return false;
//     }

//     if (emailError) {
//       Swal.fire('Error', 'Please correct your email format.', 'error');
//       return false;
//     }

//     if (password !== confirmPassword) {
//       Swal.fire('Error', 'Passwords do not match.', 'error');
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (!isEmailVerified) {
//       Swal.fire('Error', 'Please verify your email first.', 'error');
//       setLoading(false);
//       return;
//     }

//     if (!validateForm()) {
//       setLoading(false);
//       return;
//     }

//     axios
//       .post(`${URL}auth/signup/`, {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         mobile_number: formData.phoneNumber,
//         otp: parseInt(formData.otp),
//       })
//       .then(() => {
//         Swal.fire('Success', 'Your account has been created!', 'success');
//         navigate('/log');
//       })
//       .catch((error) => {
//         Swal.fire('Error', 'Registration failed. Please try again.', 'error');
//         console.error('Registration error:', error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const handleGoogleLoginSuccess = async (credentialResponse) => {
//     const token = credentialResponse.credential;
//     console.log('Received Google Token:', token);

//     try {
//       const response = await axios.post(`${URL}auth/google/login/`, { token });
//       localStorage.setItem('jwttoken', response.data.access);

//       Swal.fire({
//         title: 'Success!',
//         text: 'You have logged in with Google successfully.',
//         icon: 'success',
//         timer: 1000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate('/Home');
//       });
//     } catch (error) {
//       console.error('Google login error:', error);
//       if (error.response) {
//         console.error('Error Data:', error.response.data);
//         console.error('Error Status:', error.response.status);
//       }

//       Swal.fire({
//         title: 'Error!',
//         text: error?.response?.data?.error || 'Google login failed',
//         icon: 'error',
//         confirmButtonText: 'Try Again',
//       });
//     }
//   };

//   return (
//     <GoogleOAuthProvider clientId='563227117215-cvm1hposi4qtk3kcrb3693vsq8osefts.apps.googleusercontent.com'>
//       <div style={{
//         backgroundColor: '#f8f9fa',
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         padding: '20px 0'
//       }}>
//         <Container>
//           <Row className='justify-content-center'>
//             <Col sm={10} md={6} lg={5} style={{
//               backgroundColor: 'white',
//               borderRadius: '10px',
//               padding: '30px',
//               boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
//             }}>
//               <div style={{
//                 textAlign: 'center',
//                 marginBottom: '20px'
//               }}>
//                 <img
//                   src={Kaas}
//                   alt='KaaS Logo'
//                   style={{
//                     height: '60px',
//                     marginBottom: '20px'
//                   }}
//                 />
//                 <h2 style={{
//                   color: '#8852A0',
//                   fontSize: '28px',
//                   fontWeight: 'bold',
//                   marginBottom: '20px'
//                 }}>
//                   Sign Up
//                 </h2>
//               </div>

//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaUser />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type='text'
//                           name='firstName'
//                           placeholder='First Name'
//                           value={formData.firstName}
//                           onChange={handleChange}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaUser />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type='text'
//                           name='lastName'
//                           placeholder='Last Name'
//                           value={formData.lastName}
//                           onChange={handleChange}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className='mb-3'>
//                   <InputGroup>
//                     <InputGroup.Text style={{
//                       borderRadius: '5px 0 0 5px',
//                       backgroundColor: '#f8f9fa'
//                     }}>
//                       <FaEnvelope />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type='email'
//                       name='email'
//                       placeholder='Enter Your Email'
//                       value={formData.email}
//                       onChange={handleChange}
//                       isInvalid={!!emailError}
//                       required
//                       style={{
//                         borderRadius: '0',
//                         border: '1px solid #ced4da',
//                         padding: '10px 15px',
//                         height: '45px'
//                       }}
//                     />
//                     <Button
//                       onClick={sendOTP}
//                       disabled={otpLoading}
//                       style={{
//                         backgroundColor: '#8852A0',
//                         borderColor: '#8852A0',
//                         borderRadius: '0 5px 5px 0',
//                         height: '45px',
//                       }}
//                     >
//                       {otpLoading ? (
//                         <>
//                           <span
//                             className='spinner-border spinner-border-sm'
//                             role='status'
//                             aria-hidden='true'
//                             style={{ marginRight: '8px' }}
//                           ></span>
//                           Verifying...
//                         </>
//                       ) : (
//                         'Verify'
//                       )}
//                     </Button>
//                     <Form.Control.Feedback type='invalid'>
//                       {emailError}
//                     </Form.Control.Feedback>
//                   </InputGroup>
//                 </Form.Group>

//                 <Form.Group className='mb-3'>
//                   <PhoneInput
//                     country={'us'}
//                     value={formData.phoneNumber}
//                     onChange={handlePhoneChange}
//                     inputProps={{
//                       name: 'phoneNumber',
//                       required: true,
//                       style: {
//                         width: '100%',
//                         height: '45px',
//                         padding: '10px 15px',
//                         border: '1px solid #ced4da',
//                         borderRadius: '5px'
//                       }
//                     }}
//                   />
//                 </Form.Group>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaLock />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type={showPassword ? 'text' : 'password'}
//                           name='password'
//                           placeholder='Password'
//                           value={formData.password}
//                           onChange={handleChange}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                         <Button
//                           onClick={() => setShowPassword(!showPassword)}
//                           variant='outline-secondary'
//                           style={{ height: '45px' }}
//                         >
//                           {showPassword ? <FaEyeSlash /> : <FaEye />}
//                         </Button>
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaLock />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type={showConfirmPassword ? 'text' : 'password'}
//                           name='confirmPassword'
//                           placeholder='Confirm Password'
//                           value={formData.confirmPassword}
//                           onChange={handleChange}
//                           isInvalid={!!passwordError}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                         <Button
//                           onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                           variant='outline-secondary'
//                           style={{ height: '45px' }}
//                         >
//                           {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                         </Button>
//                         <Form.Control.Feedback type='invalid'>
//                           {passwordError}
//                         </Form.Control.Feedback>
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 {showOTPField && (
//                   <Form.Group className='mb-3'>
//                     <Form.Control
//                       type='text'
//                       name='otp'
//                       placeholder='Enter OTP'
//                       value={formData.otp}
//                       onChange={handleChange}
//                       style={{
//                         border: '1px solid #ced4da',
//                         padding: '10px 15px',
//                         height: '45px',
//                         borderRadius: '5px'
//                       }}
//                     />
//                   </Form.Group>
//                 )}

//                 <Button
//                   type='submit'
//                   className='w-100'
//                   disabled={loading}
//                   style={{
//                     backgroundColor: '#B8529E',
//                     borderColor: '#B8529E',
//                     fontSize: '18px',
//                     padding: '10px',
//                     marginTop: '15px',
//                     marginBottom: '15px',
//                     height: '50px',
//                     borderRadius: '25px',
//                     fontWeight: 'bold'
//                   }}
//                 >
//                   {loading ? (
//                     <>
//                       <span
//                         className='spinner-border spinner-border-sm'
//                         role='status'
//                         aria-hidden='true'
//                         style={{ marginRight: '8px' }}
//                       ></span>
//                       Signing Up...
//                     </>
//                   ) : (
//                     'Sign Up'
//                   )}
//                 </Button>
//               </Form>

//               <div style={{
//                 textAlign: 'center',
//                 margin: '20px 0',
//                 position: 'relative'
//               }}>
//                 <hr style={{
//                   margin: '10px 0',
//                   backgroundColor: '#e0e0e0'
//                 }} />
//                 <span style={{
//                   position: 'absolute',
//                   top: '-10px',
//                   backgroundColor: 'white',
//                   padding: '0 10px',
//                   color: '#6c757d',
//                   left: '50%',
//                   transform: 'translateX(-50%)'
//                 }}>
//                   OR
//                 </span>
//               </div>

//               <motion.div
//                 initial={{ y: 20, opacity: 0 }}
//                 animate={{ y: 0, opacity: 1 }}
//                 transition={{ delay: 0.5, duration: 0.5 }}
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                   marginBottom: "20px"
//                 }}
//               >
//                 <GoogleLogin
//                   onSuccess={handleGoogleLoginSuccess}
//                   onError={(error) => {
//                     console.error("Google login error:", error);
//                     Swal.fire({
//                       title: "Error!",
//                       text: error.message || "Google login failed",
//                       icon: "error",
//                       background: "#f8f9fa",
//                       confirmButtonColor: "#B8529E",
//                     });
//                   }}
//                   theme="outline"
//                   size="large"
//                   text="signup_with"
//                   shape="pill"
//                   logo_alignment="center"
//                 />
//               </motion.div>

//               <p style={{
//                 textAlign: 'center',
//                 marginTop: '20px',
//                 fontSize: '15px',
//                 color: '#333'
//               }}>
//                 Already Registered?{' '}
//                 <a href='/log' style={{
//                   color: '#8852A0',
//                   textDecoration: 'none',
//                   fontWeight: 'bold'
//                 }}>
//                   Sign In
//                 </a>
//               </p>

//               <p style={{
//                 textAlign: 'center',
//                 marginTop: '10px',
//                 fontSize: '12px',
//                 color: '#6c757d'
//               }}>
//                 By creating an account, you accept KaaS Terms of Services & Privacy Policy
//               </p>
//             </Col>

//             <Col md={6} lg={7} style={{ display: 'flex', alignItems: 'center' }}>
//               <div style={{ padding: '20px' }}>
//                 <h1 style={{
//                   color: '#3953A3',
//                   fontSize: '36px',
//                   fontWeight: 'bold',
//                   marginBottom: '30px'
//                 }}>
//                   Sign Up for Unending Learning!
//                 </h1>
//                 <img
//                   src={Register_Page_Laptop}
//                   alt="Registration"
//                   style={{
//                     maxWidth: '100%',
//                     height: 'auto',
//                     borderRadius: '10px',
//                     boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
//                   }}
//                 />
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </GoogleOAuthProvider>
//   );
// };

// export default RegisterPage;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';
// import { Form, Button, Container, Row, Col, InputGroup } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
// import axios from 'axios';
// import Kaas from '../Images/Kaas 4.png'
// import Register_Page_Laptop from '../Images/kaass.avif'
// import { motion } from "framer-motion";
// import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

// const RegisterPage = () => {
//   const URL = 'https://tdtlworld.com/dss-kaas-backend/';
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phoneNumber: '',
//     password: '',
//     confirmPassword: '',
//     otp: '',
//   });
//   const [emailError, setEmailError] = useState('');
//   const [passwordError, setPasswordError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [showOTPField, setShowOTPField] = useState(false);
//   const [isEmailVerified, setIsEmailVerified] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   const navigate = useNavigate();

//   useEffect(() => {
//     // Function to update window width state
//     const handleResize = () => {
//       setWindowWidth(window.innerWidth);
//     };

//     // Add event listener for window resize
//     window.addEventListener('resize', handleResize);

//     // Fetch country codes
//     axios
//       .get('https://restcountries.com/v3.1/all')
//       .catch((error) => console.error('Error fetching country codes:', error));

//     // Clean up event listener on component unmount
//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));

//     if (name === 'email') validateEmail(value);
//     if (name === 'confirmPassword') validatePasswords(formData.password, value);
//     if (name === 'password') validatePasswords(value, formData.confirmPassword);
//   };

//   const validateEmail = (email) => {
//     const emailRegex = /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/;
//     if (!emailRegex.test(email)) {
//       setEmailError(
//         'Invalid email format. Please start with a lowercase letter.'
//       );
//     } else {
//       setEmailError('');
//     }
//   };

//   const validatePasswords = (password, confirmPassword) => {
//     if (confirmPassword && password !== confirmPassword) {
//       setPasswordError('Passwords do not match');
//     } else {
//       setPasswordError('');
//     }
//   };

//   const handlePhoneChange = (value) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       phoneNumber: value,
//     }));
//   };

//   const sendOTP = () => {
//     setOtpLoading(true);
//     if (emailError) {
//       Swal.fire('Error', 'Please correct your email before verifying.', 'error');
//       setOtpLoading(false);
//       return;
//     }
//     axios
//       .post(`${URL}auth/verify-email/`, { email: formData.email })
//       .then(() => {
//         Swal.fire('OTP Sent', 'Please check your email for the OTP.', 'success');
//         setShowOTPField(true);
//         setIsEmailVerified(true);
//       })
//       .catch(() => {
//         Swal.fire('Error', 'Failed to send OTP. Please try again.', 'error');
//         setIsEmailVerified(false);
//       })
//       .finally(() => {
//         setOtpLoading(false);
//       });
//   };

//   const validateForm = () => {
//     const { firstName, lastName, phoneNumber, email, password, confirmPassword } = formData;

//     if (!firstName || !lastName) {
//       Swal.fire('Error', 'Please enter both first and last name.', 'error');
//       return false;
//     }

//     if (!phoneNumber) {
//       Swal.fire('Error', 'Invalid phone number.', 'error');
//       return false;
//     }

//     if (emailError) {
//       Swal.fire('Error', 'Please correct your email format.', 'error');
//       return false;
//     }

//     if (password !== confirmPassword) {
//       Swal.fire('Error', 'Passwords do not match.', 'error');
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (!isEmailVerified) {
//       Swal.fire('Error', 'Please verify your email first.', 'error');
//       setLoading(false);
//       return;
//     }

//     if (!validateForm()) {
//       setLoading(false);
//       return;
//     }

//     axios
//       .post(`${URL}auth/signup/`, {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.firstName,
//         last_name: formData.lastName,
//         mobile_number: formData.phoneNumber,
//         otp: parseInt(formData.otp),
//       })
//       .then(() => {
//         Swal.fire('Success', 'Your account has been created!', 'success');
//         navigate('/log');
//       })
//       .catch((error) => {
//         Swal.fire('Error', 'Registration failed. Please try again.', 'error');
//         console.error('Registration error:', error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const handleGoogleLoginSuccess = async (credentialResponse) => {
//     const token = credentialResponse.credential;
//     console.log('Received Google Token:', token);

//     try {
//       const response = await axios.post(`${URL}auth/google/login/`, { token });
//       localStorage.setItem('jwttoken', response.data.access);

//       Swal.fire({
//         title: 'Success!',
//         text: 'You have logged in with Google successfully.',
//         icon: 'success',
//         timer: 1000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate('/Home');
//       });
//     } catch (error) {
//       console.error('Google login error:', error);
//       if (error.response) {
//         console.error('Error Data:', error.response.data);
//         console.error('Error Status:', error.response.status);
//       }

//       Swal.fire({
//         title: 'Error!',
//         text: error?.response?.data?.error || 'Google login failed',
//         icon: 'error',
//         confirmButtonText: 'Try Again',
//       });
//     }
//   };

//   // Determine if we should show the right column based on screen width
//   const isMobile = windowWidth < 768; // 768px is standard breakpoint for medium devices

//   return (
//     <GoogleOAuthProvider clientId='563227117215-cvm1hposi4qtk3kcrb3693vsq8osefts.apps.googleusercontent.com'>
//       <div style={{
//         backgroundColor: '#f8f9fa',
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         padding: '20px 0'
//       }}>
//         <Container>
//           <Row className='justify-content-center'>
//             <Col xs={12} sm={12} md={isMobile ? 12 : 6} lg={isMobile ? 12 : 5} style={{
//               backgroundColor: 'white',
//               borderRadius: '10px',
//               padding: '30px',
//               boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//               marginBottom: isMobile ? '20px' : '0'
//             }}>
//               <div style={{
//                 textAlign: 'center',
//                 marginBottom: '20px'
//               }}>
//                 <img
//                   src={Kaas}
//                   alt='KaaS Logo'
//                   onClick={() => navigate("/db-shiksha/kaas/")}

//                   style={{
//                     height: '60px',
//                     marginBottom: '20px'
//                   }}
//                 />
//                 <h2 style={{
//                   color: '#8852A0',
//                   fontSize: '28px',
//                   fontWeight: 'bold',
//                   marginBottom: '20px'
//                 }}>
//                   Sign up as Student
//                 </h2>
//               </div>

//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                       {/* <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaUser />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type='text'
//                           name='firstName'
//                           placeholder='First Name'
//                           value={formData.firstName}
//                           onChange={handleChange}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                       </InputGroup> */}
//                        <Form.Label>First Name</Form.Label>
//   <InputGroup>
//     <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//       <FaUser />
//     </InputGroup.Text>
//     <Form.Control
//       type="text"
//       name="firstName"
//       value={formData.firstName}
//       onChange={handleChange}
//       required
//       style={{
//         border: '1px solid #ced4da',
//         padding: '10px 15px',
//         height: '45px',
//       }}
//     />
//   </InputGroup>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                     <Form.Label>Last Name</Form.Label>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaUser />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type='text'
//                           name='lastName'
//                           // placeholder='Last Name'
//                           value={formData.lastName}
//                           onChange={handleChange}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className='mb-3'>
//                 <Form.Label> Enter Email</Form.Label>
//                   <InputGroup>
//                     <InputGroup.Text style={{
//                       borderRadius: '5px 0 0 5px',
//                       backgroundColor: '#f8f9fa'
//                     }}>
//                       <FaEnvelope />
//                     </InputGroup.Text>
//                     <Form.Control
//                       type='email'
//                       name='email'
//                       // placeholder='Enter Your Email'
//                       value={formData.email}
//                       onChange={handleChange}
//                       isInvalid={!!emailError}
//                       required
//                       style={{
//                         borderRadius: '0',
//                         border: '1px solid #ced4da',
//                         padding: '10px 15px',
//                         height: '45px'
//                       }}
//                     />
//                     <Button
//                       onClick={sendOTP}
//                       disabled={otpLoading}
//                       style={{
//                         backgroundColor: '#8852A0',
//                         borderColor: '#8852A0',
//                         borderRadius: '0 5px 5px 0',
//                         height: '45px',
//                       }}
//                     >
//                       {otpLoading ? (
//                         <>
//                           <span
//                             className='spinner-border spinner-border-sm'
//                             role='status'
//                             aria-hidden='true'
//                             style={{ marginRight: '8px' }}
//                           ></span>
//                           Verifying...
//                         </>
//                       ) : (
//                         'Verify'
//                       )}
//                     </Button>
//                     <Form.Control.Feedback type='invalid'>
//                       {emailError}
//                     </Form.Control.Feedback>
//                   </InputGroup>
//                 </Form.Group>

//                 <Form.Group className='mb-3'>
//                 <Form.Label>Phone Number </Form.Label>
//                   <PhoneInput
//                     country={'us'}
//                     value={formData.phoneNumber}
//                     onChange={handlePhoneChange}
//                     inputProps={{
//                       name: 'phoneNumber',
//                       required: true,
//                       style: {
//                         width: '100%',
//                         height: '45px',
//                         padding: '10px 15px',
//                         border: '1px solid #ced4da',
//                         borderRadius: '5px'
//                       }
//                     }}
//                   />
//                 </Form.Group>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                     <Form.Label>Enter Password</Form.Label>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaLock />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type={showPassword ? 'text' : 'password'}
//                           name='password'
//                           // placeholder='Password'
//                           value={formData.password}
//                           onChange={handleChange}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                         <Button
//                           onClick={() => setShowPassword(!showPassword)}
//                           variant='outline-secondary'
//                           style={{ height: '45px' }}
//                         >
//                           {showPassword ? <FaEyeSlash /> : <FaEye />}
//                         </Button>
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className='mb-3'>
//                     <Form.Label>Confirm Password</Form.Label>
//                       <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa' }}>
//                           <FaLock />
//                         </InputGroup.Text>
//                         <Form.Control
//                           type={showConfirmPassword ? 'text' : 'password'}
//                           name='confirmPassword'
//                           // placeholder='Confirm Password'
//                           value={formData.confirmPassword}
//                           onChange={handleChange}
//                           isInvalid={!!passwordError}
//                           required
//                           style={{
//                             border: '1px solid #ced4da',
//                             padding: '10px 15px',
//                             height: '45px'
//                           }}
//                         />
//                         <Button
//                           onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                           variant='outline-secondary'
//                           style={{ height: '45px' }}
//                         >
//                           {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                         </Button>
//                         <Form.Control.Feedback type='invalid'>
//                           {passwordError}
//                         </Form.Control.Feedback>
//                       </InputGroup>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 {showOTPField && (
//                   <Form.Group className='mb-3'>
//                     <Form.Label>Enter OTP</Form.Label>
//                     <Form.Control
//                       type='text'
//                       name='otp'
//                       // placeholder='Enter OTP'
//                       value={formData.otp}
//                       onChange={handleChange}
//                       style={{
//                         border: '1px solid #ced4da',
//                         padding: '10px 15px',
//                         height: '45px',
//                         borderRadius: '5px'
//                       }}
//                     />
//                   </Form.Group>
//                 )}

//                 <Button
//                   type='submit'
//                   className='w-100'
//                   disabled={loading}
//                   style={{
//                     backgroundColor: '#B8529E',
//                     borderColor: '#B8529E',
//                     fontSize: '18px',
//                     padding: '10px',
//                     marginTop: '15px',
//                     marginBottom: '15px',
//                     height: '50px',
//                     borderRadius: '25px',
//                     fontWeight: 'bold'
//                   }}
//                 >
//                   {loading ? (
//                     <>
//                       <span
//                         className='spinner-border spinner-border-sm'
//                         role='status'
//                         aria-hidden='true'
//                         style={{ marginRight: '8px' }}
//                       ></span>
//                       Signing Up...
//                     </>
//                   ) : (
//                     'Sign Up'
//                   )}
//                 </Button>
//               </Form>

//               <div style={{
//                 textAlign: 'center',
//                 margin: '20px 0',
//                 position: 'relative'
//               }}>
//                 <hr style={{
//                   margin: '10px 0',
//                   backgroundColor: '#e0e0e0'
//                 }} />
//                 <span style={{
//                   position: 'absolute',
//                   top: '-10px',
//                   backgroundColor: 'white',
//                   padding: '0 10px',
//                   color: '#6c757d',
//                   left: '50%',
//                   transform: 'translateX(-50%)'
//                 }}>
//                   OR
//                 </span>
//               </div>

//               <motion.div
//                 initial={{ y: 20, opacity: 0 }}
//                 animate={{ y: 0, opacity: 1 }}
//                 transition={{ delay: 0.5, duration: 0.5 }}
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                   marginBottom: "20px"
//                 }}
//               >
//                 <GoogleLogin
//                   onSuccess={handleGoogleLoginSuccess}
//                   onError={(error) => {
//                     console.error("Google login error:", error);
//                     Swal.fire({
//                       title: "Error!",
//                       text: error.message || "Google login failed",
//                       icon: "error",
//                       background: "#f8f9fa",
//                       confirmButtonColor: "#B8529E",
//                     });
//                   }}
//                   theme="outline"
//                   size="large"
//                   text="signup_with"
//                   shape="pill"
//                   logo_alignment="center"
//                 />
//               </motion.div>

//               <p style={{
//                 textAlign: 'center',
//                 marginTop: '20px',
//                 fontSize: '15px',
//                 color: '#333'
//               }}>
//                 Already Registered?{' '}
//                 <a href='/log' style={{
//                   color: '#8852A0',
//                   textDecoration: 'none',
//                   fontWeight: 'bold'
//                 }}>
//                   Sign In
//                 </a>
//               </p>

//               <p style={{
//                 textAlign: 'center',
//                 marginTop: '10px',
//                 fontSize: '12px',
//                 color: '#6c757d'
//               }}>
//                 By creating an account, you accept KaaS Terms of Services & Privacy Policy
//               </p>
//             </Col>

//             {/* Right column with image - hidden on mobile */}
//             {!isMobile && (
//               <Col md={6} lg={7} style={{ display: 'flex', alignItems: 'start' }}>
//                 <div style={{ padding: '20px' }}>
//                   <h1 style={{
//                     color: '#3953A3',
//                     fontSize: '36px',
//                     fontWeight: 'bold',
//                     marginBottom: '30px'
//                   }}>
//                     Sign Up for Unending Learning!
//                   </h1>
//                   <img
//                     src={Register_Page_Laptop}
//                     alt="Registration"
//                     style={{
//                       width: '100%',
//                       height: '550px',
//                       objectFit: 'cover',
//                       borderRadius: '10px',
//                       boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
//                     }}
//                   />
//                 </div>
//               </Col>
//             )}
//           </Row>
//         </Container>
//       </div>
//     </GoogleOAuthProvider>
//   );
// };

// export default RegisterPage;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // Ensure this is correctly imported
import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS
import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import VetLearnLogo from "../Images/Kaas 4.png"; // Assuming Kaas.png is the KaaS logo
import RegisterImage from "../Images/kaass.avif"; // Image for the right panel
import { motion } from "framer-motion";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

// Vetrina Theme Colors
const VETRINA_PURPLE = "#B8529E";
const VETRINA_ORANGE = "#FF6600";
const VETRINA_TEXT_PRIMARY = "#333";
const VETRINA_TEXT_SECONDARY = "#555";
const VETRINA_BACKGROUND_LIGHT = "#f8f9fa"; // Light greyish background
const VETRINA_ACCENT_LIGHT_PURPLE = "#ede7f6"; // A very light purple for subtle backgrounds or highlights

const RegisterPage = () => {
  const URL = "https://tdtlworld.com/dss-kaas-backend/"; // Replace if backend URL changes
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    otp: "",
  });
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOTPField, setShowOTPField] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Optional: Fetch country codes if needed, though react-phone-number-input handles this
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    if (name === "email") validateEmail(value);
    if (name === "confirmPassword") validatePasswords(formData.password, value);
    if (name === "password") validatePasswords(value, formData.confirmPassword);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-z][a-z0-9.+_-]*@[a-z0-9.-]+\.[a-z]{2,}$/i; // Allow uppercase start
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format.");
    } else {
      setEmailError("");
    }
  };

  const validatePasswords = (password, confirmPassword) => {
    if (confirmPassword && password !== confirmPassword) {
      setPasswordError("Passwords do not match.");
    } else {
      setPasswordError("");
    }
  };

  const handlePhoneChange = (value) => {
    setFormData((prevState) => ({ ...prevState, phoneNumber: value }));
  };

  const sendOTP = () => {
    if (!formData.email || emailError) {
      Swal.fire({
        title: "Error",
        text: "Please enter a valid email before verifying.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return;
    }
    setOtpLoading(true);
    axios
      .post(`${URL}auth/verify-email/`, { email: formData.email })
      .then(() => {
        Swal.fire({
          title: "OTP Sent",
          text: "Please check your email for the OTP.",
          icon: "success",
          confirmButtonColor: VETRINA_PURPLE,
        });
        setShowOTPField(true);
        setIsEmailVerified(true);
      })
      .catch(() => {
        Swal.fire({
          title: "Error",
          text: "Failed to send OTP. Please check your email or try again.",
          icon: "error",
          confirmButtonColor: VETRINA_ORANGE,
        });
        setIsEmailVerified(false);
      })
      .finally(() => setOtpLoading(false));
  };

  const validateForm = () => {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      password,
      confirmPassword,
    } = formData;
    if (!firstName || !lastName) {
      Swal.fire({
        title: "Error",
        text: "Please enter both first and last name.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return false;
    }
    if (!phoneNumber) {
      Swal.fire({
        title: "Error",
        text: "Please enter a valid phone number.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return false;
    }
    if (emailError) {
      Swal.fire({
        title: "Error",
        text: "Please correct your email format.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return false;
    }
    if (password !== confirmPassword) {
      Swal.fire({
        title: "Error",
        text: "Passwords do not match.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return false;
    }
    if (showOTPField && !formData.otp) {
      Swal.fire({
        title: "Error",
        text: "Please enter the OTP received in your email.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isEmailVerified && showOTPField) {
      // Check if OTP field is shown but not necessarily "verified" by a separate API call yet
      Swal.fire({
        title: "Error",
        text: "Please enter the OTP sent to your email.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return;
    }
    if (!showOTPField) {
      // If OTP field isn't even shown, means email verification step was skipped
      Swal.fire({
        title: "Error",
        text: "Please verify your email first.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
      return;
    }

    if (!validateForm()) return;

    setLoading(true);
    axios
      .post(`${URL}auth/signup/`, {
        email: formData.email,
        password: formData.password,
        first_name: formData.firstName,
        last_name: formData.lastName,
        mobile_number: formData.phoneNumber,
        otp: formData.otp, // Send as string to preserve leading zeros
      })
      .then(() => {
        Swal.fire({
          title: "Success!",
          text: "Your KaaS account has been created!",
          icon: "success",
          confirmButtonColor: VETRINA_PURPLE,
        });
        navigate("/db-shiksha/kaas/login"); // Navigate to login page
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.detail ||
          error.response?.data?.email?.[0] ||
          error.response?.data?.mobile_number?.[0] ||
          "Registration failed. Please try again.";
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonColor: VETRINA_ORANGE,
        });
      })
      .finally(() => setLoading(false));
  };

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    const token = credentialResponse.credential;
    setLoading(true); // Show loading state for Google Sign-Up/Login
    try {
      // Assuming the same endpoint handles both login and signup for Google
      const response = await axios.post(`${URL}auth/google/login/`, { token });
      localStorage.setItem("jwttoken", response.data.access);
      Swal.fire({
        title: "Success!",
        text: "Signed in with Google successfully!",
        icon: "success",
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        confirmButtonColor: VETRINA_PURPLE,
      }).then(() => navigate("/db-shiksha/kaas/student/home")); // Navigate to a dashboard or home page
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.error ||
          "Google sign-in failed. Please try again.",
        icon: "error",
        confirmButtonColor: VETRINA_ORANGE,
      });
    } finally {
      setLoading(false);
    }
  };

  const isMobile = windowWidth < 768;

  // Styles
  const formControlStyle = {
    border: "1px solid #ced4da",
    padding: "10px 15px",
    height: "48px", // Slightly increased height
    borderRadius: "8px", // More rounded
    fontSize: "1rem",
  };

  const inputGroupTextStyle = {
    backgroundColor: VETRINA_ACCENT_LIGHT_PURPLE, // Light purple accent
    border: `1px solid ${VETRINA_PURPLE}`,
    borderRight: "none",
    color: VETRINA_PURPLE,
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
    padding: "0 15px",
  };

  const inputGroupControlStyle = {
    ...formControlStyle,
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    borderLeft: "none",
  };

  const phoneInputStyle = {
    width: "100%",
    height: "48px",
    padding: "10px 15px",
    border: "1px solid #ced4da",
    borderRadius: "8px",
    fontSize: "1rem",
  };
  const formLabelStyle = {
    fontWeight: "500",
    color: VETRINA_TEXT_SECONDARY,
    marginBottom: "8px",
    fontSize: "0.9rem",
  };

  return (
    <GoogleOAuthProvider clientId="563227117215-cvm1hposi4qtk3kcrb3693vsq8osefts.apps.googleusercontent.com">
      <div
        style={{
          background: `linear-gradient(135deg, ${VETRINA_ACCENT_LIGHT_PURPLE} 0%, ${VETRINA_BACKGROUND_LIGHT} 100%)`,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          padding: "30px 0",
          fontFamily: "'Poppins', sans-serif", // Assuming Poppins is globally available
        }}
      >
        <Container>
          <Row className="justify-content-center align-items-center">
            {/* Registration Form Column */}
            <Col
              xs={12}
              md={isMobile ? 12 : 7}
              lg={isMobile ? 12 : 6}
              style={{ marginBottom: isMobile ? "30px" : "0" }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                style={{
                  backgroundColor: "white",
                  borderRadius: "15px",
                  padding: isMobile ? "25px" : "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                }}
              >
                <div style={{ textAlign: "center", marginBottom: "25px" }}>
                  <img
                    src={VetLearnLogo}
                    alt="VetLearn Logo"
                    onClick={() => navigate("/db-shiksha/kaas/student/home")}
                    style={{
                      height: "70px",
                      marginBottom: "15px",
                      cursor: "pointer",
                    }}
                  />
                  <h2
                    style={{
                      color: VETRINA_PURPLE,
                      fontSize: "1.8rem",
                      fontWeight: "bold",
                    }}
                  >
                    Create Your KaaS Account
                  </h2>
                  <p
                    style={{ color: VETRINA_TEXT_SECONDARY, fontSize: "1rem" }}
                  >
                    Join our community of learners!
                  </p>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formLabelStyle}>
                          First Name
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text style={inputGroupTextStyle}>
                            <FaUser />
                          </InputGroup.Text>
                          <Form.Control
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            style={inputGroupControlStyle}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formLabelStyle}>
                          Last Name
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text style={inputGroupTextStyle}>
                            <FaUser />
                          </InputGroup.Text>
                          <Form.Control
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                            style={inputGroupControlStyle}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label style={formLabelStyle}>
                      Email Address
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={inputGroupTextStyle}>
                        <FaEnvelope />
                      </InputGroup.Text>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        isInvalid={!!emailError}
                        required
                        style={{
                          ...inputGroupControlStyle,
                          borderRight: "none",
                        }}
                      />
                      <Button
                        onClick={sendOTP}
                        disabled={otpLoading}
                        style={{
                          backgroundColor: VETRINA_PURPLE,
                          borderColor: VETRINA_PURPLE,
                          height: "48px",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                        }}
                      >
                        {otpLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              style={{ marginRight: "5px" }}
                            ></span>
                            Verifying
                          </>
                        ) : (
                          "Verify Email"
                        )}
                      </Button>
                      <Form.Control.Feedback type="invalid">
                        {emailError}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={formLabelStyle}>Phone Number</Form.Label>
                    <PhoneInput
                      defaultCountry="US"
                      value={formData.phoneNumber}
                      onChange={handlePhoneChange}
                      inputComponent={Form.Control}
                      inputProps={{
                        name: "phoneNumber",
                        required: true,
                        style: phoneInputStyle,
                      }}
                    />
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formLabelStyle}>Password</Form.Label>
                        <InputGroup>
                          <InputGroup.Text style={inputGroupTextStyle}>
                            <FaLock />
                          </InputGroup.Text>
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            style={{
                              ...inputGroupControlStyle,
                              borderRight: "none",
                            }}
                          />
                          <Button
                            onClick={() => setShowPassword(!showPassword)}
                            variant="outline-secondary"
                            style={{
                              height: "48px",
                              borderColor: "#ced4da",
                              borderLeft: "none",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              color: VETRINA_PURPLE,
                            }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </Button>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formLabelStyle}>
                          Confirm Password
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text style={inputGroupTextStyle}>
                            <FaLock />
                          </InputGroup.Text>
                          <Form.Control
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            isInvalid={!!passwordError}
                            required
                            style={{
                              ...inputGroupControlStyle,
                              borderRight: "none",
                            }}
                          />
                          <Button
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            variant="outline-secondary"
                            style={{
                              height: "48px",
                              borderColor: "#ced4da",
                              borderLeft: "none",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              color: VETRINA_PURPLE,
                            }}
                          >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </Button>
                          <Form.Control.Feedback type="invalid">
                            {passwordError}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>

                  {showOTPField && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      style={{ overflow: "hidden" }} // Important for height animation
                    >
                      <Form.Group className="mb-3">
                        <Form.Label style={formLabelStyle}>
                          Enter OTP
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="otp"
                          value={formData.otp}
                          onChange={handleChange}
                          required
                          style={formControlStyle}
                          placeholder="Check your email for OTP"
                        />
                      </Form.Group>
                    </motion.div>
                  )}

                  <Button
                    type="submit"
                    className="w-100"
                    disabled={loading}
                    style={{
                      background: `linear-gradient(45deg, ${VETRINA_ORANGE}, ${VETRINA_PURPLE})`,
                      borderColor: "transparent",
                      fontSize: "1.1rem",
                      padding: "12px",
                      marginTop: "15px",
                      marginBottom: "20px",
                      height: "50px",
                      borderRadius: "25px",
                      fontWeight: "bold",
                      boxShadow: `0 4px 15px rgba(184, 82, 158, 0.3)`,
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          style={{ marginRight: "8px" }}
                        ></span>
                        Creating Account...
                      </>
                    ) : (
                      "Sign Up"
                    )}
                  </Button>
                </Form>

                <div
                  style={{
                    textAlign: "center",
                    margin: "20px 0",
                    position: "relative",
                  }}
                >
                  <hr style={{ backgroundColor: "#e0e0e0" }} />
                  <span
                    style={{
                      position: "absolute",
                      top: "-12px",
                      backgroundColor: "white",
                      padding: "0 10px",
                      color: VETRINA_TEXT_SECONDARY,
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "0.9rem",
                    }}
                  >
                    OR
                  </span>
                </div>

                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "20px",
                  }}
                >
                  <GoogleLogin
                    onSuccess={handleGoogleLoginSuccess}
                    onError={(error) =>
                      Swal.fire({
                        title: "Error!",
                        text: error.message || "Google sign-up failed",
                        icon: "error",
                        confirmButtonColor: VETRINA_ORANGE,
                      })
                    }
                    theme="outline"
                    size="large"
                    text="signup_with"
                    shape="pill"
                    logo_alignment="center"
                  />
                </motion.div>

                <p
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "0.95rem",
                    color: VETRINA_TEXT_PRIMARY,
                  }}
                >
                  Already have an account?{" "}
                  <a
                    href="/db-shiksha/kaas/login"
                    style={{
                      color: VETRINA_PURPLE,
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                    onMouseOver={(e) => (e.target.style.color = VETRINA_ORANGE)}
                    onMouseOut={(e) => (e.target.style.color = VETRINA_PURPLE)}
                  >
                    Sign In
                  </a>
                </p>
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    fontSize: "0.8rem",
                    color: VETRINA_TEXT_SECONDARY,
                  }}
                >
                  By creating an account, you agree to KaaS's Terms of Service &
                  Privacy Policy.
                </p>
              </motion.div>
            </Col>

            {/* Image Column - hidden on mobile */}
            {!isMobile && (
              <Col
                md={5}
                lg={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  style={{ padding: "20px", textAlign: "center" }}
                >
                  <h1
                    style={{
                      color: VETRINA_PURPLE,
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                      marginBottom: "20px",
                      textShadow: "1px 1px 2px rgba(0,0,0,0.05)",
                    }}
                  >
                    Unlock a World of Animal Health & Nutrition Expertise!
                  </h1>
                  <p
                    style={{
                      color: VETRINA_TEXT_SECONDARY,
                      fontSize: "1.1rem",
                      marginBottom: "30px",
                      lineHeight: "1.6",
                    }}
                  >
                    Join KaaS to access cutting-edge courses, connect with
                    experts, and grow your skills in the animal health industry.
                  </p>
                  <img
                    src={RegisterImage}
                    alt="VetLearn Registration"
                    style={{
                      width: "90%",
                      maxWidth: "500px",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: "15px",
                      boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
                    }}
                  />
                </motion.div>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </GoogleOAuthProvider>
  );
};

export default RegisterPage;
